import { StyleSheet, Platform } from 'react-native'

const isWeb = Platform.OS === 'web'

export default StyleSheet.create({
  container: {
    position: 'absolute',
    zIndex: 9999,
    borderRadius: 12,
    paddingVertical: 12,
    paddingHorizontal: 16,
    shadowColor: '#000',
    shadowOpacity: 0.15,
    shadowRadius: 5,
    shadowOffset: { width: 0, height: 2 },
    elevation: 5,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 50,
    maxWidth: isWeb ? 400 : '90%',
    alignSelf: 'center',
  },
  
  // Positions
  positionTop: {
    top: isWeb ? 20 : 60,
    left: isWeb ? 20 : '5%',
    right: isWeb ? 20 : '5%',
  },
  positionBottom: {
    bottom: isWeb ? 20 : 40,
    left: isWeb ? 20 : '5%',
    right: isWeb ? 20 : '5%',
  },
  positionCenter: {
    top: '50%',
    left: isWeb ? 20 : '5%',
    right: isWeb ? 20 : '5%',
    transform: [{ translateY: -25 }],
  },

  // Content
  contentContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconContainer: {
    marginRight: 12,
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  textContainer: {
    flex: 1,
  },
  text: {
    color: '#fff',
    fontSize: 15,
    fontWeight: '500',
    lineHeight: 20,
  },
  closeButton: {
    marginLeft: 12,
    padding: 4,
    borderRadius: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    width: 24,
    height: 24,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: 16,
  },

  // Types
  info: { 
    backgroundColor: '#3498db',
    borderLeftWidth: 4,
    borderLeftColor: '#2980b9',
  },
  success: { 
    backgroundColor: '#27ae60',
    borderLeftWidth: 4,
    borderLeftColor: '#229954',
  },
  error: { 
    backgroundColor: '#e74c3c',
    borderLeftWidth: 4,
    borderLeftColor: '#c0392b',
  },
  warning: { 
    backgroundColor: '#f39c12',
    borderLeftWidth: 4,
    borderLeftColor: '#e67e22',
  },

  // Container pour multiple notifications
  notificationsContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 9999,
  },
})